import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "qa-record" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Recording test ")
const _hoisted_3 = {
  key: 0,
  class: "recording-container"
}
const _hoisted_4 = {
  key: 1,
  class: "playback-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AudioPlayer = _resolveComponent("AudioPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.isPlayingBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_ctx.isRecording)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "record-btn clear-btn big",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.record()), ["prevent"]))
              }, [
                _createVNode(_component_Icon, {
                  name: "fiber_manual_record",
                  style: {"color":"red"}
                })
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "stop-record-btn clear-btn big",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.stopRecording()), ["prevent"]))
              }, [
                _createVNode(_component_Icon, {
                  name: "stop",
                  style: {"color":"red"}
                })
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_AudioPlayer, {
            src: _ctx.audioPlayback?.audioEl.src
          }, null, 8, ["src"]),
          _createElementVNode("button", {
            class: "stop-btn clear-btn big",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.stop()), ["prevent"]))
          }, [
            _createVNode(_component_Icon, {
              name: "stop",
              style: {"color":"blue"}
            })
          ])
        ]))
  ]))
}